import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { decodedLtiTokenHasLtiAudienceClaims, jwtDecode } from 'ilios-common/utils/jwt-utils';

export default class LtiLoginRoute extends Route {
  @service serverVariables;
  @service session;
  @service router;
  @service iliosConfig;

  async model({ token }) {
    const decodedJwt = jwtDecode(token);
    if (!decodedLtiTokenHasLtiAudienceClaims(decodedJwt)) {
      throw new Error('Access denied');
    }
    const jwt = await this.getNewToken(token);
    await this.session.authenticate('authenticator:ilios-jwt', { jwt });
    this.router.transitionTo('index');
  }

  async getNewToken(ltiToken) {
    const apiHost = this.iliosConfig.apiHost;
    const url = `${apiHost}/auth/token`;
    const response = await fetch(url, {
      headers: {
        'X-JWT-Authorization': `Token ${ltiToken}`,
      },
    });
    if (response.ok) {
      const obj = await response.json();
      return obj.jwt;
    } else {
      throw new Error('Unable to extract token from refresh request');
    }
  }
}
